var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEnvelopeWithCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3335 3.27197C13.7477 3.27197 14.0835 3.60776 14.0835 4.02197V7.17197C14.0835 7.58619 13.7477 7.92197 13.3335 7.92197C12.9193 7.92197 12.5835 7.58619 12.5835 7.17197V4.02197C12.5835 3.60776 12.9193 3.27197 13.3335 3.27197Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 3.27197C1.74771 3.27197 2.0835 3.60776 2.0835 4.02197V9.99997C2.0835 10.6904 2.64304 11.25 3.3335 11.25H6.6855C7.09971 11.25 7.4355 11.5858 7.4355 12C7.4355 12.4142 7.09971 12.75 6.6855 12.75H3.3335C1.81462 12.75 0.583496 11.5189 0.583496 9.99997V4.02197C0.583496 3.60776 0.919283 3.27197 1.3335 3.27197Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66683 3.41675C2.34438 3.41675 2.0835 3.67763 2.0835 4.00008V4.02208C2.0835 4.24593 2.20761 4.45215 2.40659 4.55729C2.40649 4.55724 2.40668 4.55735 2.40659 4.55729L6.44033 6.68183C6.99951 6.97651 7.66757 6.97665 8.22695 6.68234L12.272 4.55183C12.4634 4.45104 12.5835 4.25201 12.5835 4.03541V4.02208C12.5835 3.68763 12.3126 3.41675 11.9782 3.41675H2.66683ZM0.583496 4.00008C0.583496 2.8492 1.51595 1.91675 2.66683 1.91675H11.9782C13.141 1.91675 14.0835 2.8592 14.0835 4.02208V4.03541C14.0835 4.80814 13.6556 5.51845 12.971 5.879C12.971 5.879 12.971 5.87899 12.971 5.879L8.92567 8.00967C7.9291 8.534 6.73812 8.53424 5.74133 8.009C5.74127 8.00897 5.74138 8.00903 5.74133 8.009L1.70733 5.88433C1.01714 5.5201 0.583496 4.80346 0.583496 4.02208V4.00008Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5411 9.48066C15.8279 9.77951 15.8182 10.2543 15.5193 10.5411L12.3936 13.5411C12.1033 13.8197 11.6449 13.8196 11.3547 13.5409L9.48046 11.7406C9.18173 11.4537 9.17216 10.9789 9.4591 10.6802C9.74603 10.3815 10.2208 10.3719 10.5195 10.6588L11.8745 11.9603L14.4807 9.4589C14.7795 9.17208 15.2543 9.18182 15.5411 9.48066Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelopeWithCheckmark);
export default __webpack_public_path__ + "static/media/icon-envelope-with-checkmark.2e13f191cfc675af6726d3af42d20b24.svg";
export { ForwardRef as ReactComponent };